import React from "react"

export const PRINTCOLUMNS = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Role",
    accessor: "primaryRole",
  },
  {
    Header: "Services Offered",
    accessor: "servicesOffered",
    height: "100px",
    Cell: (row: any) => {
      return <span title={row.value}>{row.value}</span>
    },
  },
  {
    Header: "Time available",
    accessor: "availabilityTimeFrame",
    Cell: (row: any) => {
      return <span className="availabletime">{row.value?.length > 0 ? row.value?.join("\n") : null}</span>
    },
  },
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Email",
    accessor: "email",
    Cell: (row: any) => {
      return <span title={row.value}>{row.value}</span>
    },
  },
]
